import { W as WuiListItem$1, d as defineCustomElement$1 } from './p-Cx1d0m6y.js';

const WuiListItem = WuiListItem$1;
const defineCustomElement = defineCustomElement$1;

export { WuiListItem, defineCustomElement };
